import SimulatorWorldCup from "../components/simulatorWorldCup/simulatorWorldCup.js";

export default function SimulatorWorldCupPage() {

  return (
    <div className="simulator-worldcup-page">
      <SimulatorWorldCup />
    </div>
  );
}